import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

class ExportFieldListPopup extends React.Component {

  constructor(props) {
    super(props);
    const keys = Object.keys(props.model.fields);
    const list = keys.map(key => { return { key, label: props.model.fields[key].label_name, field_type: props.model.fields[key].field_type, check: true } });
    this.state = { list, mainCheck: true };
  }

  onChange = index => {
    let list = [ ...this.state.list];
    list[index].check = !list[index].check;
    let mainCheck = true;
    for(let i = 0; i < list.length; i++) {
      mainCheck = list[i].check;
      if(!mainCheck) {
        break;
      }
    }
    this.setState({ ...this.state, list, mainCheck });
  }

  onAllChange = event => {
    let list = [ ...this.state.list];
    for(let i = 0; i < list.length; i++) {
      list[i].check = event.target.checked;
    }
    this.setState({ ...this.state, list, mainCheck: event.target.checked });
  }

  onSubmit = () => {
    const fields = this.state.list.filter(field => field.check);
    this.props.onSubmit(fields);
  }

  render() {
    const uiList = this.state.list.map( (field, i) =>
      <li key={`field_selection_${i}`}>
        <div className="mb-3">
          <Form.Check onChange={() => this.onChange(i)} checked={field.check} />
          <span className="input-field">{field.label}</span>
        </div>
      </li>
    );

    return (
      <Modal {...this.props} size="md" aria-labelledby="contained-modal-title-vcenter" centered className="export-model"
        onExit={() => this.onSubmit(null) }>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Export Fields <Form.Check onChange={this.onAllChange} checked={this.state.mainCheck} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="model-check-list">{uiList}</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.props.onSubmit(this.state.list)}>Submit</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ExportFieldListPopup;